import React, {FunctionComponent, useEffect, useState} from 'react';

import {Stack, TextField} from "@mui/material";
import {useAppSelector} from '../../../../Config/Hooks';
import {RootState} from '../../../../Config/Store';
import {SkidType} from './types/Skid';
import ChartHeatmap from './ChartHeatmap';

import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {startOfDay, endOfDay, isWithinInterval} from 'date-fns';
import {LocalDateTimeFormatISO} from "../../../../Utils/DateFormatPatternUtils";
import {ACard, Skeleton} from "@atiautomacao/ati-ui-library";
import DataNotFound from "../../../../Shared/Components/DataNotFoundMessage";
import useInterval from "../../../../Shared/Hooks/useInterval";

const PowerPUForInvertersChart: FunctionComponent<{ powerPlant: any; }> = ({powerPlant}) => {

    const openSubMenu = useAppSelector((state: any) => state.layout.openSubMenu);
    const {entities, isLoading} = useAppSelector((state: RootState) => state.dashboardNavigationMenu);
    const userConfig = useAppSelector((state: RootState) => state.userConfigurarion);

    const initListSkid = () => {
        const skidList = new Array<any>();
        if(entities){
            entities.filter((element) => element.id === powerPlant.id).map((item) =>
                item.skidList.forEach((skid) => skidList.push(skid))
            );
        }
        return skidList;
    }
    const [entitiesPUList, setEntitiesPUList] = useState<Array<SkidType>>(initListSkid());

    const [date, setDate] = useState<Date | null>(startOfDay(new Date()));

    useEffect(() => {
        setEntitiesPUList(initListSkid())
        setDate(startOfDay(new Date()))
    }, [powerPlant]);

    useInterval(() => {
        setEntitiesPUList(initListSkid())
    }, userConfig.mainUpdateInterval, 2000)

    const [content, setContent] = useState<JSX.Element>()

    useEffect(() => {
        if(isLoading){
            setContent(<Skeleton animation="wave" height={350} variant="rounded" width={'100%'} />)
        }else if(entitiesPUList && entitiesPUList.length > 0){
            setContent(<ChartHeatmap skidList={entitiesPUList} date={date} />)
        }else{
            setContent(<DataNotFound boxStyle={{height: 350, width: '100%'}}/>)
        }
    }, [isLoading, date]);

    return (
        <ACard
            key={`chart-power-pu-${openSubMenu}`}
            styleProps={{
                cardStyle: { height: 463 },
                contentStyle: { padding: '0 16px', height: 408, alignItems: 'center'},
                subTitleStyle: { display: 'none' },
                footerStyle: {paddingTop: 40}
            }}
            title="Potência PU"
            ariaLabel={"dashboard-station-power-pu-chart"}
            headerControlsPosition={"subheader"}
            headerControls={
                <Stack direction="row" sx={{ marginTop: '16px', marginRight: '16px' }} >
                    <LocalizationProvider dateAdapter={AdapterDayjs}
                    >
                        <DatePicker
                            label="Dia"
                            renderInput={(params) => <TextField 
                                sx={{  '& .MuiOutlinedInput-root': 
                                    { borderRadius: '8px', color: 'gray', height: '30px', width: '155px' } }} {...params} />}
                            value={date}
                            inputFormat={"DD/MM/YYYY"}
                            onChange={(newValue) => {
                                if (newValue && isWithinInterval(new Date(newValue), { start: new Date('1980-01-01'), end: endOfDay(new Date()) })) {
                                    setDate(startOfDay(new Date(LocalDateTimeFormatISO(newValue))));
                                }
                                return;
                            }}
                        />
                    </LocalizationProvider>
                </Stack>
            }
        >
            <>
                {content != null && content}
            </>

        </ACard>
    )
}

export default PowerPUForInvertersChart;
